module.exports = __webpack_public_path__ + "static/phoneservice-5d3813b8cd6187ad6168e43d39c3a031.svg";